<script lang="ts">
  import type {Poem} from './types'
  import {t} from './i18n'
  import SmallPoem from './poems/SmallPoem.svelte'
  import Placeholder from './shared/Placeholder.svelte'
  import LoadMore from './shared/LoadMore.svelte'

  let poems: Poem[] | undefined
  const poemsUrl = '/poems/recommended'
</script>

<div class="row">
  <div class="grid-section">
    <div class="heading with-filter inner-heading">
      <h2>{t.topbar.recommended}</h2>
    </div>

    {#if poems && poems.length}
      <div class="grid three">
        {#each poems as poem}
          <div class="grid__item">
            <SmallPoem {poem}/>
          </div>
        {/each}
      </div>
    {:else}
      <Placeholder placeholder={t.placeholder.no_poems} loading={!poems}/>
    {/if}

    <LoadMore bind:items={poems} url={poemsUrl}/>
  </div>
</div>
